/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import {
    Group,
    SearchBar,
    Control,
    getDateNYC,
    isAfterFourPM,
    DateRangePickerDropDown,
    MultiSelectDropDown
} from '@insticator/insticator-ui'; // iui-material
import ContentTypeSort from 'material/embeds/controlbar/contenttypesort/contenttypesort';
import ContentIndicatorSort from 'material/embeds/controlbar/contentindictatorsort/contentindicatorsort';
import ContentSort from 'material/embeds/controlbar/contentsort/contentsort'
import LabelsManagementDropdown from 'material/embeds/controlbar/labelsmanagementdropdown/labelsmanagementdropdown_container'
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/controlbar/controlbar_styles';



/* ========== ~~~~~~~~~~ CONTROL BAR : CHILD ~~~~~~~~~~ ========== */
class ControlBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            types: [],
            status: [],
        }
    }

    handleSelectStatus = (status) => {
        this.setState({
            status: status
        });
        this.props.handleSelectStatus(status);
    };

    handleSelectType = (types) => {
        this.setState({
            types: types
        });
        this.props.handleSelectType(types);
    };

    renderActive = () => {
        if(!!this.props.handleActive){
            return(
            <div className={'active'}>
                <Control selected={this.props.active === true} text={`Active`} value={true} handleSelect={this.props.handleActive} />
                <Control selected={this.props.active === false} text={`Archive`} value={false} handleSelect={this.props.handleActive} />
            </div>
            )
        }
    };

    renderSortBy = () => {
      if(this.props.page === 'embedcontent'){
          return (
              <div className={'sortby'}>
                  <span className={'text'}>Sort by:</span>
                  <ContentSort sort={this.props.handleSort}/>
              </div>
          )
      }
      return null;
    };

    applyFilters = () => this.props.applyFilters();


    renderShowing = () => (
        <div className={'showing'}>
            {this.props.organize && <span className={`text`}>Showing: </span>}
            {!this.props.handleSelectStatus ? null :
                <ContentIndicatorSort
                    buttonAction={this.props.applyFilters && this.applyFilters}
                    status={ this.state.status }
                    disabled={this.props.active === false}
                    allStatus={[
                        { value: true, name: 'online' },
                        { value: false, name: 'offline' }
                    ]}
                    handleSelect={ this.handleSelectStatus }
                />
            }
            {!this.props.handleSelectType ? null :
                <ContentTypeSort
                    buttonAction={this.props.applyFilters && this.applyFilters}
                    types={this.state.types}
                    allTypes={[
                        { value: 'QUIZ', name: 'quiz' },
                        { value: 'POLL', name: 'poll' },
                        { value: 'STORY', name: 'story' }
                    ]}
                    handleSelect={ this.handleSelectType }
                />
            }
            {this.renderDateRangePicker()}
            {this.renderLabels()}
        </div>
    );

    renderDateRangePicker = () => {
        if(this.props.updateDateRange){
            return (
                <DateRangePickerDropDown
                    updateRange={this.props.updateDateRange}
                    range={this.props.dateRange}
                    disabledDays={[ { after: new Date() } ]}
                    handleApply={this.props.applyFilters}
                    customRangeClick={this.props.customRangeClick}
                    customDateRanges={[
                        {ctaText: 'Anytime', range: null, indicator: 'Anytime'},
                        {ctaText: 'Today', range: 'TODAY', indicator: 'Today'},
                        {ctaText: 'Yesterday', range: 'YESTERDAY', indicator: 'Yesterday'},
                        {ctaText: "Last 7 Days", range: 7},
                        {ctaText: "Last 30 Days", range: 30},
                        {ctaText: "Last 90 Days", range: 90}
                        ]}
                    indicatorTitle={'Date modified'}
                />
            )
        }
    };

    renderLabels = () => this.props.selectLabel && (<LabelsManagementDropdown selectLabel={this.props.selectLabel}
                                                    selectedLabels={this.props.selectedLabels}
                                                    buttonAction={() => this.props.applyFilters()}/>)

    render() {
        return (
            <div className={`controlbar ${this.props.classes.controlbar} disabled-${this.props.disabled}`}>
                <div className={'searchlabel'}>
                    <SearchBar value={this.props.searchDefaultValue} placeholder={this.props.searchPlaceholder} onChange={this.props.searchOnChange} />
                    <div className={'label'}>{this.props.label && this.props.label}</div>
                </div>
                <Group name={`filters`} direction={`horizontal`}>
                    {this.renderActive()}
                    {this.renderSortBy()}
                    {this.renderShowing()}
                </Group>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ControlBar);
